"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

// Toaster (sonner ±36 KB raw) + NextTopLoader (nprogress) di-mount DEFERRED:
// keduanya tidak dibutuhkan di jalur kritis first paint, tapi dulu ikut
// initial bundle SEMUA route dari root layout (audit
// 2026-09-24-landing-performance-audit). Mount saat browser idle (timeout
// 2 dtk) — siap sebelum user sempat memicu toast/navigasi pertama.
// Trade-off disadari: toast yang dipicu <2 dtk pertama sebelum mount
// tidak tampil (toast nyata selalu hasil interaksi user, bukan load).
const SonnerToaster = dynamic(
  () => import("@/components/ui/sonner").then((m) => ({ default: m.Toaster })),
  { ssr: false },
);

const NextTopLoader = dynamic(() => import("nextjs-toploader"), { ssr: false });

export function DeferredGlobalUi() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const w = window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
      cancelIdleCallback?: (id: number) => void;
    };
    let idleId: number;
    let timeoutId: ReturnType<typeof setTimeout>;
    if (w.requestIdleCallback)
      idleId = w.requestIdleCallback(() => setReady(true), { timeout: 2000 });
    else timeoutId = setTimeout(() => setReady(true), 300);
    return () => {
      if (w.cancelIdleCallback && idleId != null) w.cancelIdleCallback(idleId);
      else clearTimeout(timeoutId);
    };
  }, []);

  if (!ready) return null;
  return (
    <>
      <NextTopLoader color="var(--foreground)" />
      <SonnerToaster richColors position="top-right" />
    </>
  );
}
